import { Controller } from "stimulus";

const itemSelector = "[data-copy-down-target='item']"

export default class extends Controller {
  static targets = ["item"];
  static values  = {
    triggerSetSpecimenTypeId: { type: String, default: "" },
  }

  connect() { }

  copy(e) {
    e.preventDefault();
    const currentItem = this.findTargetByQuerySelector(itemSelector, e)
    const currentOrderNumber = currentItem.dataset.ordernumber
    let references = e.target.dataset.references
    if (!references) return
    references = references.replace(/[\s,]+/g, ',');
    const referencesArr = references.split(",")
    // Not too many items on this loop, max 2 items
    for (let r = 0; r < referencesArr.length; r++) {
      const ref = referencesArr[r];
      const input = currentItem.querySelector(`[id^="${ref}"]`)
      if (input) {
        const currentValue = input.value
        this.fillBelowItems(currentOrderNumber, ref, currentValue)
      }
    }

  }

  // we gonna select below Items grater than currentOrderNumber
  fillBelowItems(currentOrderNumber, ref, currentValue){
    // When we're incrementing the input fields, we start from the field that the copy-down was initiated from,
    // instead of the field immediately following it.
    const belowItems = this.getBelowItems(currentOrderNumber)

    for (let i = 0; i < belowItems.length; i++) {
      const pickedItem = belowItems[i];
      const selectedInputs = this.getInputs(pickedItem, ref)      
      // Not too many items on this loop, max 2 items so far
      for (let j = 0; j < selectedInputs.length; j++) {
        const element = selectedInputs[j];
        if (element){
          element.value = currentValue
          this.setSpecimenTypeId(element, ref, currentValue)
        }
      }
    }
  }

  //  if we meet specimen_type_id we need to refresh specimen type desc fields.
  setSpecimenTypeId(element, ref, currentValue){
    if (ref === 'specimen_type_id' && element.type == 'hidden'){
      // just once that will be enough to fill specimen type description list
      if (this.triggerSetSpecimenTypeIdValue != currentValue){
        this.dispatch("triggerAutocompleteChangeEventFromCopyDown", { detail: { item: element} })
      }
      this.triggerSetSpecimenTypeIdValue = currentValue
    }
  }

  getInputs(pickedItem, ref){
    return Array.from(pickedItem.querySelectorAll("input, select, textarea")).filter(el => el.id === ref)
  }

  getBelowItems(currentOrderNumber){
    return Array.from(this.itemTargets.filter(el => Number(el.dataset.ordernumber) > currentOrderNumber))
  }

  findTargetByQuerySelector(selector, e){
    const dataId = e.target.dataset.id
    return document.querySelector(`${selector}[data-id="${dataId}"]`)
  }

}
